import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { FDStack } from '@facet-wealth/design';
import { OverviewSectionInfo } from './OverviewSectionInfo';

export const OverviewSectionInfos = ({ collection }) => {
  if (!collection) {
    return null;
  }
  return (
    <FDStack direction={'column'} spacing={4}>
      {collection.resources().list().map((info) => <OverviewSectionInfo resource={info} key={info.id()} />)}
    </FDStack>
  );
};

OverviewSectionInfos.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};
